import { styled } from '@mui/system';

export const GridList = styled('div')({
  display: 'flex',
  flexWrap: 'wrap',
});
